import { render, staticRenderFns } from "./upcomingADT.vue?vue&type=template&id=3153ed1e&scoped=true"
import script from "./upcomingADT.vue?vue&type=script&lang=js"
export * from "./upcomingADT.vue?vue&type=script&lang=js"
import style0 from "./upcomingADT.vue?vue&type=style&index=0&id=3153ed1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3153ed1e",
  null
  
)

export default component.exports